<template>
  <div class="home-wrapper">
    <SwiperList :swiperList="swiperList"></SwiperList>
    <div class="totalnav" v-if="+cos.cosflg === 1">
      <!--<div class="totalnav-left ">-->
      <!--<div class="icon"></div>-->
      <!--<span @click="$router.push({path: '/reg'})">免费注册</span>-->
      <!--</div>-->
      <NumScroll/>
    </div>
    <div class="container">
      <div class="main">
        <div>
          <div class="center">
            <div>
              <!-- 采购公告 -->
              <div class="sidebar_a">
                <div class="subnav home_nav">
                  <div class="menu">
                    <!-- <Nav :navs="navs" @change="navChange"></Nav> -->
                    <div style="font-size: 18px; margin-left: 10px">
                      采购公告
                    </div>
                  </div>
                  <div class="more" @click="toMore(1)"><a>更多 MORE>></a></div>
                </div>
                <!-- <home-main></home-main> -->
                <list-card></list-card>
              </div>

              <!-- 成交公告 -->
              <div class="sidebar_a">
                <div class="subnav home_nav">
                  <div class="menu">
                    <!-- <Nav :navs="navs" @change="navChange"></Nav> -->
                    <div style="font-size: 18px; margin-left: 10px">
                      成交公告
                    </div>
                  </div>
                  <div class="more" @click="toMore(1)"><a>更多 MORE>></a></div>
                </div>
                <list-card :type="60"></list-card>
              </div>

              <!-- 更正公告 -->
              <!-- <div class="sidebar_a">
                <div class="subnav home_nav ">
                  <div class="menu">
                    <div style="font-size:18px;margin-left:10px;">更正公告</div>
                  </div>
                  <div v-if="false" class="more" @click="toMore(1)"><a>更多>></a></div>
                </div>
                <list-card :type="1"></list-card>
              </div> -->

              <!-- 变更公告 -->
              <div class="sidebar_a">
                <div class="subnav home_nav">
                  <div class="menu">
                    <!-- <Nav :navs="navs" @change="navChange"></Nav> -->
                    <div style="font-size: 18px; margin-left: 10px">
                      变更公告
                    </div>
                  </div>
                  <div class="more" @click="toMore(1)"><a>更多 MORE>></a></div>
                </div>
                <list-card :type="2"></list-card>
              </div>

              <!-- 预成交公示 -->
              <div class="sidebar_a">
                <div class="subnav home_nav">
                  <div class="menu">
                    <!-- <Nav :navs="navs" @change="navChange"></Nav> -->
                    <div style="font-size: 18px; margin-left: 10px">
                      预成交公示
                    </div>
                  </div>
                  <div class="more" @click="toMore(1)"><a>更多 MORE>></a></div>
                </div>
                <list-card :type="5"></list-card>
              </div>
            </div>

            <div class="sidebar_b">
              <div class="box qqkf">
                <!-- {{picAddr + cosInfo.cosonlineqq}} -->
                <div class="qqkf-item">
                  <div class="point-QQ">
                    <img
                      src="../assets/img/QQ.png"
                      style="width: 100%"
                      alt=""
                    />
                  </div>
                  <span class="text">QQ在线客服</span>
                </div>
                <div class="kf-img">
                  <img :src="picAddr + cosInfo.cosonlineqq" alt="" />
                </div>
              </div>
              <div class="box" v-for="(obj, i) in rightList" :key="i">
                <div class="title" :class="'menuicon_' + i">
                  <i><span class="point"></span></i>
                  <span class="text">{{ obj.label }}</span>
                  <span class="more" @click="rightToMore(obj)"
                    ><a>更多>></a></span
                  >
                </div>
                <div class="list">
                  <div v-for="(item, index) in obj.notices" :key="index">
                    <div class="row">
                      <div class="point"></div>
                      <!--:class="{active: activeTab1 === index}"-->
                      <li @click="activeChange(obj, index, item)">
                        {{ item.name }}
                      </li>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="lefttitle"><span>友情链接LINKS</span></div>
          <div class="blogroll">
            <blogroll></blogroll>
          </div>
        </div>
        <div class="warnmsg">
          为了正确浏览本站页面，达到最佳的阅读和视觉效果，请务必使用以下浏览器:
          <span
            ><a href="http://browser.qq.com/" target="_blank"
              >QQ浏览器(极速模式)</a
            >
          </span>
          <span
            ><a href="http://www.firefox.com.cn/" target="_blank"
              >火狐浏览器(Mozilla Firefox)</a
            ></span
          >
          <span
            ><a
              href="https://www.google.cn/chrome/browser/desktop/index.html"
              target="_blank"
              >谷歌浏览器(Google Chrome)</a
            >
          </span>
        </div>
      </div>
    </div>
    <el-dialog
      title="温馨提示"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="dialogClose"
    >
      <div class="dialog_warnmsg">
        为了正确浏览本站页面，达到最佳的阅读和视觉效果，请务必使用以下浏览器：
        <div>
          <a href="http://browser.qq.com/" target="_blank"
            >QQ浏览器(极速模式)</a
          >
        </div>
        <div>
          <a href="http://www.firefox.com.cn/" target="_blank"
            >火狐浏览器(Mozilla Firefox)</a
          >
        </div>
        <div>
          <a
            href="https://www.google.cn/chrome/browser/desktop/index.html"
            target="_blank"
            >谷歌浏览器(Google Chrome)</a
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
        <el-button type="primary" @click="dialogVisible = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="popDesc ? popDesc.noticetitle : '无'"
      :close-on-click-modal="true"
      :visible.sync="popflg"
      width="50%"
      :before-close="popflgClose"
    >
      <div v-if="popDesc">
        <div v-html="popDesc.noticedesc"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SwiperList from "./common/SwiperList";
import Blogroll from "./common/Blogroll";
// import HomeMain from '../components/common/HomeMain'
import ListCard from "../components/common/ListCard";
import request from "@/utils/request";
import common from "../mixin/common";
import NumScroll from "./common/NumScroll";
export default {
  name: "Home",
  components: { SwiperList, Blogroll, ListCard, NumScroll },
  mixins: [common],
  data() {
    return {
      // navs: ['竞价公告', '竞拍公告'],
      navs: ["采购项目"],
      swiperList: [],
      // swiperList: [{url: '../../assets/img/guanggao/swiper_bg1.png'}, {url: '../../assets/img/guanggao/swiper_bg2.png'}, {url: "../../assets/img/guanggao/swiper_bg3.png"}, {url: ''}],
      // total: {},
      cosInfo: {},
      rightList: [],
      activeTab1: "",
      activeTab2: "",
      activeTab3: "",
      dialogVisible: false,
      popflg: false,
      popDesc: {},
    };
  },
  created() {
    let userAgent = navigator.userAgent;
    if (
      userAgent.indexOf("Firefox") < 0 &&
      userAgent.indexOf("Chrome") < 0 &&
      userAgent.indexOf("QQBrowser") < 0
    ) {
      // this.dialogVisible = true
    }
    this.getWmenu();
    this.getSwiperList();
    this.getRightList();
    // this.getWebTotal();
    this.getCosInfo();
    this.getpopflg();
  },
  methods: {
    async getCosInfo() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/web/web/getCosbyid",
        params: { cosid: this.cosId },
      });
      // console.log(res, '---')
      this.cosInfo = res[0];
      this.loading = false;
    },
    async getpopflg() {
      let res = await request({
        method: "get",
        url: "/web/web/getNotice",
        params: { cosid: this.cosId },
      });

      this.popDesc = res[0];

      if (res.length > 0) {
        this.popflg = true;
      }
    },
    async popflgClose() {
      this.popflg = false;
    },
    async getWmenu() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/web/web/getWmenuTree",
        params: { cosid: this.cosId },
      });
      this.loading = false;
      this.$store.commit("changeState", { menus: res.list });
      if (!this.parentActiveTab) {
        this.$store.commit("changeState", { parentActiveTab: res.list[0] });
      }
    },
    dialogClose() {
      this.dialogVisible = false;
    },
    async getSwiperList() {
      if (this.menus && this.menus.length) {
        let res = await request({
          method: "get",
          url: "/web/web/getCarfigList",
          params: { carfigwmenuid: this.menus[0].value, cosid: this.cosId },
        });
        this.swiperList = res;
      }
    },
    // Too Doo
    async getRightList() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/web/web/getLeftWmenuList",
        params: { cosid: this.cosId },
      });
      this.rightList = res;
      this.loading = false;
    },
    rightToMore(obj) {
      let menu = this.menus.find((v) => v.value === obj.value);
      this.$store.commit("changeState", { parentActiveTab: menu });
      if (menu.children && menu.children.length) {
        menu.children[0].last = "";
        // this.$store.commit('changeState', {'childActiveTab': this.parentActiveTab.children && this.parentActiveTab.children.length ? this.parentActiveTab.children[0] : ''})
        this.$store.commit("changeState", { childActiveTab: menu.children[0] });
      }
      this.$router.push({ name: menu.url, query: { id: menu.index } });
    },
    toMore(index) {
      let menu = this.menus.find((v) => v.index === index);
      // 先注释
      // let m = menu.children.findIndex(v => v.value === 0)
      // if (m !== -1) {
      //   menu.children.splice(0, 1)
      // }
      this.$store.commit("changeState", { parentActiveTab: menu });
      if (menu.children) {
        menu.children[0].last = "";
        this.$store.commit("changeState", { childActiveTab: menu.children[0] });
      }
      this.$router.push({ name: menu.url, query: { id: menu.index } });
    },
    navChange(value, obj) {
      console.log(value, obj, "首页菜单点击");
    },
    activeChange(obj, index, item) {
      if (item.pre.showtype === "4") {
        if (item.url) {
          // var tempwindow = window.open('_blank')
          // tempwindow.location = this.picAddr + item.url
          this.downFile(item.url);
        }
      } else {
        this.activeTab1 = index;
        let menu = this.menus.find((v) => v.value === obj.value);
        if (menu.children.length) {
          let preIndex = menu.children.findIndex(
            (v) => v.value === item.pre.value
          );
          item.pre.index = preIndex;
          item.pre.last = {
            index: index,
            value: item.value,
            url: item.url,
            name: item.name,
            content: item.content,
          };
          this.$store.commit("changeState", { childActiveTab: item.pre });
        } else {
          menu.last = {
            index: index,
            value: item.value,
            url: item.url,
            name: item.name,
            content: item.content,
          };
        }
        this.$store.commit("changeState", { parentActiveTab: menu });
        this.$router.push({ name: obj.url, query: { id: menu.index } });
      }
      // if (type === 1) {
      //   this.activeTab1 = index
      //   let obj = item.parent
      //   obj.last = {name: item.name, content: item.content}
      //   this.$store.commit('changeState', {'childActiveTab': obj})
      //   let menu = this.menus.find(v => v.index === 3)
      //   this.$store.commit('changeState', {'parentActiveTab': menu})
      //   this.$router.push({name: menu.url, query: {id: menu.index}})
      // } else if (type === 2) {
      //   this.activeTab2 = index
      //   if (item.url) {
      //     var tempwindow = window.open('_blank')
      //     tempwindow.location = item.url
      //   }
      // } else if (type === 3) {
      //   this.activeTab3 = index
      // }
    },
  },
  computed: {
    ...mapGetters([
      "picAddr",
      "parentActiveTab",
      "childActiveTab",
      "menus",
      "cosId",
      "cos",
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

@media screen and (min-width: 769px) {
  .home-wrapper {
    // .totalnav {
    //   display: flex;
    //   align-items: center;
    //   height: 100px;
    //   background-color: $color-bg-white;
    //   .totalnav-left {
    //     color: $color-orange;
    //     flex-grow: 1;
    //     display: flex;
    //     align-items: center;
    //     justify-content: flex-end;
    //     cursor: pointer;
    //     span {
    //       padding-left: 10px;
    //     }
    //     .icon {
    //       width: 50px;
    //       height: 50px;
    //       background-size: 50px 50px;
    //       background-image: url("../assets/img/icon_regit.png");
    //     }
    //   }
    //   .totalnav-right {
    //     color: $color-orange;
    //     flex-grow: 1;
    //     display: flex;
    //     align-items: center;
    //     cursor: pointer;
    //     span {
    //       padding-left: 10px;
    //     }
    //     .icon {
    //       width: 50px;
    //       height: 50px;
    //       background-size: 50px 50px;
    //       background-image: url("../assets/img/icon_expert.png");
    //     }
    //   }
    // }
    .container {
      display: flex;
      justify-content: center;
      padding: 50px 0;
      .main {
        width: 1201px;
        .center {
          margin-bottom: 22px;
          display: flex;
          /*align-items: center;*/
          .title {
            font-size: $fontsize-large-x;
            font-weight: bold;
          }
          .more {
            font-weight: normal;
            font-size: $fontsize-medium;
            color: #999999;
          }
          .sidebar_a {
            flex: 3;
            margin: 20px 0;
            .subnav {
              // margin-bottom: 15px;
              display: flex;
              text-align: left;
              border-left: 3px solid $color-orange;
              font-weight: bold;
              align-items: center;
              .menu {
                flex: 1;
              }
            }
          }
          .sidebar_b {
            padding-left: 20px;
            flex: 1;
            .qqkf {
              .qqkf-item {
                padding-bottom: 20px;
                display: flex;
                .text {
                  font-size: 18px;
                  font-weight: bold;
                }
              }
              .kf-img {
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
            .box {
              padding-bottom: 30px;
              .title {
                display: flex;
                align-items: center;
                padding-bottom: 20px;
                i {
                  display: block;
                  margin-right: 10px;
                  width: 21px;
                  height: 21px;
                  background-size: 21px 21px;
                }
                .text {
                  flex: 1;
                }
              }
              .menuicon_0 {
                i {
                  background-image: url("../assets/img/icon_caozuozhinan.png");
                }
              }
              .menuicon_1 {
                i {
                  background-image: url("../assets/img/icon_wenjianxiazai.png");
                }
              }
              .menuicon_2 {
                i {
                  background-image: url("../assets/img/icon_hangyedongtai.png");
                }
              }
              .point-QQ {
                width: 21px;
                height: 21px;
                margin-right: 10px;
              }
              .list {
                width: 241px;
                height: 276px;
                background-color: $color-bg-white;
                padding: 20px 15px;
                .row {
                  padding-bottom: 20px;
                  display: flex;
                  align-items: center;
                  .point {
                    width: 2px;
                    height: 2px;
                    border-radius: 50%;
                    border: 2px solid $color-orange;
                    margin-right: 5px;
                  }
                  li {
                    list-style: none;
                    font-size: 14px;
                    color: $color-light-gray;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                  }
                  li:hover {
                    cursor: pointer;
                    color: $color-orange;
                  }
                  .active {
                    color: $color-orange;
                  }
                }
              }
            }
          }
        }
        .lefttitle {
          margin-bottom: 22px;
          border-left: 3px solid $color-orange;
          span {
            padding-left: 20px;
            font-size: $fontsize-large-x;
            font-weight: bold;
          }
        }
        .blogroll {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .warnmsg {
          text-align: center;
          padding-top: 30px;
          font-weight: bold;
          span {
            padding-right: 8px;
          }
          span a:hover {
            color: $color-orange;
          }
        }
      }
    }
    .dialog_warnmsg {
      display: flex;
      flex-direction: column;
      align-items: center;
      /*justify-content: center;*/
      line-height: 30px;
      font-size: $fontsize-large;
      div a:hover {
        color: $color-orange;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .home-wrapper {
    .container {
      .main {
        .center {
          .sidebar_a {
            padding-top: 10px;
            margin: 20px 8px;
            .subnav {
              display: flex;
              justify-content: space-between;
              border-left: 3px solid $color-orange;
              .menu {
                align-items: center;
                font-weight: bold;
              }
              .more {
                padding-top: 5px;
                font-weight: normal;
                font-size: $fontsize-medium-s;
                color: #999999;
              }
            }
          }
          .sidebar_b {
            .qqkf {
              .qqkf-item {
                display: flex;
                align-items: center;
                .point-QQ {
                  width: 1.5em;
                  height: 1.5em;
                  img {
                    width: 100%;
                    height: 100%;
                  }
                }
                .text {
                }
              }
              .kf-img {
                width: 20em;
                height: 25em;
                margin: 20px auto;
                // overflow: hidden;
                border-radius: 5px;
                // padding: 5px 0;
                // margin: 0 5px;
                -moz-box-shadow: 1px 1px 7px #9c9c9c;
                -webkit-box-shadow: 1px 1px 7px #9c9c9c;
                box-shadow: 1px 1px 7px #9c9c9c;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
            .box {
              margin: 10px;
              .title {
                display: flex;
                align-items: center;
                i {
                  margin-right: 10px;
                  width: 21px;
                  height: 21px;
                  background-size: 21px 21px;
                  .point {
                  }
                }
                .text {
                  flex: 1;
                }
                .more {
                  padding-top: 5px;
                  font-weight: normal;
                  font-size: $fontsize-medium-s;
                  color: #999999;
                }
              }
              .menuicon_0 {
                i {
                  background-image: url("../assets/img/icon_caozuozhinan.png");
                }
              }
              .menuicon_1 {
                i {
                  background-image: url("../assets/img/icon_wenjianxiazai.png");
                }
              }
              .menuicon_2 {
                i {
                  background-image: url("../assets/img/icon_hangyedongtai.png");
                }
              }
              .list {
                margin: 20px auto;
                padding: 10px 5px;
                border-radius: 5px;
                -moz-box-shadow: 1px 1px 7px #9c9c9c;
                -webkit-box-shadow: 1px 1px 7px #9c9c9c;
                box-shadow: 1px 1px 7px #9c9c9c;
                .row {
                  padding-bottom: 20px;
                  display: flex;
                  align-items: center;
                  margin: 5px 0;
                  font-size: $fontsize-large;
                  .point {
                    width: 2px;
                    height: 2px;
                    border-radius: 50%;
                    border: 2px solid $color-orange;
                    margin-right: 5px;
                  }
                  li {
                    list-style: none;
                    font-size: 14px;
                    color: $color-light-gray;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                  }
                }
              }
            }
          }
        }
        .lefttitle {
          padding-left: 20px;
          font-size: 18px;
          font-weight: 700;
        }
        .warnmsg {
          display: none;
        }
      }
    }
  }
}
</style>